module.exports = __webpack_public_path__ + "static/img/rank_196.2d51a24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_196.png
// module id = mTRB
// module chunks = 1